function isLocalDevHost() {
    if (typeof location === 'undefined') return false
    const h = location.hostname
    return h === 'localhost' || h === '127.0.0.1'
}

const pathnames = {
    VUE_APP_OPEN_H5: '/pages/openAccount.html#/', // 开户H5
    VUE_APP_EDDA_H5: '/edda', // 存入资金 h5 地址
    VUE_APP_EDDA_H5_APP: '/edda_app', // 存入资金 h5 地址
    VUE_APP_EDDA_CURRENCY_APP: '/edda_app/selectCurrency/', // 存入资金-选择币种页面
    VUE_APP_CURRENCY_H5: '/edda/currency/exchange', // 货币兑换H5
    VUE_APP_CURRENCY_H5_APP: '/edda_app/currency/exchange', // 货币兑换H5
    VUE_APP_OPEN_ACCOUNT_PAGE: '/pages/startAccount.html#/', // 开户页面链接
    VUE_APP_RISK_PAGE: '/wealth/riskAssessment.html', // 风险测评页面链接
    VUE_APP_OPEN_FUND_PAGE: '/pages/fundAccount.html#/', // 基金开户页面链接
    VUE_APP_DERIVATIVE_PAGE: '/pages/derivative.html#/', // 衍生品权限开通页面链接
    VUE_APP_PI_APPLY: '/pages/PICertification.html#/', // PI 申请页面
    VUE_APP_BUILDER_PAGE: '/pages/builderPage.html#/', // h5生成器页面
    VUE_APP_FUND_ALLOCATION_PAGE: '/edda_app/fundAllocation', // 存入资金 资金调拨页面
    VUE_APP_WEALTH_COMMONOUTSIDE_PAGE: '/wealth/commonOutside.html#/', // 睿银站外通用h5页面
    VUE_APP_PDF_CMAPS: '/assets/pdf/cmaps/', // pdf字体库
}
Object.entries(pathnames).forEach(([k, v]) => {
    Object.defineProperty(pathnames, k, {
        get() {
            if (/^http(s)?/.test(v)) return v
            let origin = location.origin
            // 本地 localhost 保留当前 origin；其余开发环境仍指向 sit，方便联调
            if (process.env.NODE_ENV === 'development' && !isLocalDevHost()) {
                origin = 'https://sit.mfosunhani.com'
            }
            return `${origin}${v}`
        },
        enumerable: false,
        configurable: false,
    })
})

export default pathnames
